import { render, staticRenderFns } from "./ReferAndEarn.vue?vue&type=template&id=13f8da9e&scoped=true"
import script from "./ReferAndEarn.vue?vue&type=script&lang=js"
export * from "./ReferAndEarn.vue?vue&type=script&lang=js"
import style0 from "./ReferAndEarn.vue?vue&type=style&index=0&id=13f8da9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8da9e",
  null
  
)

export default component.exports